
 export const time = () => {
    const date = new Date()
    const realTime = {}
    realTime.day = date.getDay()
    realTime.hours = date.getHours()
    realTime.min = date.getMinutes()
    return realTime
}

export const getSundays = () =>{
    let today = new Date();
    let nextSunday = new Date();

    let sunday = new Date(today.getTime() - today.getDay() * 24 * 3600 * 1000);
    nextSunday.setDate(sunday.getDate() + 7);
    let obj = {}
    obj.sunday = sunday.getTime()
    obj.nextSunday = nextSunday.getTime()

    return obj
}

export const makeDate = (ms) =>{
    let date = new Date(ms)
    return `${date.getDate()}/${date.getMonth()+1}/${date.getFullYear()}`
}

export const fullTime = (num) => {
    let obj = {}
    
    switch(num){
        case 0:
            obj.day = 'Sun'
            obj.workTime = '12:00 PM to 9:00 PM'
            break

        case 1:
            obj.day = 'Mon'
            obj.workTime = 'Closed'
            break

        case 2:
            obj.day = 'Tue'
            obj.workTime = '12:00 PM to 8:00 PM'
            break

        case 3:
            obj.day = 'Wed'
            obj.workTime = '12:00 PM to 8:00 PM'
            break

        case 4:
            obj.day = 'Thu'
            obj.workTime = '12:00 PM to 8:00 PM'
            break

        case 5:
            obj.day = 'Fri'
            obj.workTime = '12:00 PM to 9:00 PM'
            break

        case 6:
            obj.day = 'Sat'
            obj.workTime = '12:00 PM to 9:00 PM'
            break

        default:
            obj.day = 'Default'
            obj.workTime = '12:00 PM to 8:00 PM'
            break

    }
    return obj 
}

